var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "close_icon",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "transform-origin": "center center",
    transform: "rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 4.88075e-05H1.26C0.92 -0.00995119 0.61 0.120049 0.37 0.360049C0.13 0.590049 0 0.910049 0 1.25005V20.24C0 20.93 0.56 21.49 1.25 21.49H9.41C10.1 21.49 10.66 20.93 10.66 20.24C10.66 19.55 10.1 18.99 9.41 18.99H2.5V2.50005H18.99V9.35005C18.99 10.04 19.55 10.6 20.24 10.6C20.93 10.6 21.49 10.04 21.49 9.35005V1.25005C21.5 0.560049 20.94 4.88075e-05 20.25 4.88075e-05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.24 12.03H13.28C12.59 12.03 12.03 12.59 12.03 13.28V20.24C12.03 20.93 12.59 21.49 13.28 21.49H20.99V21.24C21.29 21.01 21.49 20.65 21.49 20.24V13.28C21.5 12.59 20.93 12.03 20.24 12.03ZM14.53 18.99V14.53H18.99V18.99H14.53Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.55001 10.2801C4.55001 10.9701 5.11001 11.5301 5.80001 11.5301H10.28C10.97 11.5301 11.53 10.9701 11.53 10.2801V5.80008C11.53 5.11008 10.97 4.55008 10.28 4.55008C9.59001 4.55008 9.03001 5.11008 9.03001 5.80008V7.26008L5.64001 3.87008C5.17001 3.40008 4.35001 3.40008 3.87001 3.87008C3.64001 4.11008 3.51001 4.42008 3.51001 4.75008C3.51001 5.08008 3.64001 5.40008 3.88001 5.63008L7.27001 9.02008H5.81001C5.12001 9.03008 4.55001 9.59008 4.55001 10.2801Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.e39d819b1faafbc26c160da8e2576950.svg";
export { ForwardRef as ReactComponent };